// Converts dataURL to File
// Please refer to the links below for a better understanding of the function.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match
// https://developer.mozilla.org/en-US/docs/Web/API/Window/atob
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array
export function dataURLtoFile(dataurl: string, filename: string) {
  if (!dataurl) {
    return;
  }
  let dataParts = dataurl?.split(','),
    mimeType = dataParts[0].match(/:(.*?);/)![1],
    binaryString = atob(dataParts[dataParts.length - 1]),
    binaryStringLength = binaryString.length,
    unit8Array = new Uint8Array(binaryStringLength);
  while (binaryStringLength--) {
    unit8Array[binaryStringLength] =
      binaryString.charCodeAt(binaryStringLength);
  }
  return new File([unit8Array], filename, { type: mimeType });
}
